export default "__VITE_ASSET___p$9SLUa__"